import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase/client';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [sessionReady, setSessionReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    void supabase.auth.getSession().then(({ data }) => setSessionReady(Boolean(data.session)));
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      setSessionReady(Boolean(session));
    });
    return () => data.subscription.unsubscribe();
  }, []);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (password.length < 10) {
      setError('La contraseña debe tener al menos 10 caracteres.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    setError('');
    const { error: updateError } = await supabase.auth.updateUser({ password });
    setLoading(false);

    if (updateError) {
      setError(updateError.message);
      return;
    }

    setSuccess(true);
    await supabase.auth.signOut();
    setTimeout(() => navigate('/login', { replace: true }), 1200);
  };

  return (
    <main className="min-h-screen bg-background-50 flex items-center justify-center p-6">
      <section className="w-full max-w-md rounded-2xl border border-background-200 bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-foreground-900 font-heading">Crear nueva contraseña</h1>
        <p className="mt-2 text-sm text-foreground-600">
          Define una contraseña privada para acceder a FoodDash.
        </p>

        {!sessionReady && !success && (
          <div className="mt-5 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
            Este enlace no contiene una sesión válida o ya expiró. Solicita uno nuevo desde la pantalla de acceso.
          </div>
        )}

        {success ? (
          <div className="mt-5 rounded-lg border border-green-200 bg-green-50 p-3 text-sm text-green-800">
            Contraseña actualizada. Regresando al inicio de sesión…
          </div>
        ) : (
          <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
            <label className="block text-sm font-semibold text-foreground-700">
              Nueva contraseña
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="new-password"
                className="mt-1.5 h-12 w-full rounded-xl border border-background-300 px-4 focus:border-primary-400 focus:outline-none"
              />
            </label>
            <label className="block text-sm font-semibold text-foreground-700">
              Confirmar contraseña
              <input
                type="password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                autoComplete="new-password"
                className="mt-1.5 h-12 w-full rounded-xl border border-background-300 px-4 focus:border-primary-400 focus:outline-none"
              />
            </label>
            {error && <p className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
            <button
              type="submit"
              disabled={!sessionReady || loading}
              className="h-12 w-full rounded-xl bg-primary-500 font-semibold text-white disabled:opacity-50"
            >
              {loading ? 'Actualizando…' : 'Guardar contraseña'}
            </button>
          </form>
        )}
      </section>
    </main>
  );
}
